export const DELAY = 5000
export const ERROR = 'error'
export const ERROR_DELAY = 10000
export const INFO = 'info'
export const SUCCESS = 'success'
